export default "__VITE_ASSET__DIfiiHWl__"